const steps = [
  ['Выберите точку', 'Кликните на карте или найдите адрес — навигация доступна без регистрации.'],
  ['Анализ опасностей', 'Система оценивает подверженность точки каждой из 13 опасностей.'],
  ['Совокупный риск', 'Единый балл риска с разбивкой по опасностям и пояснениями.'],
  ['Отчёт PDF', 'Выгрузка результата со снимком карты, таблицей и легендой.'],
];

export default function HowItWorks() {
  return <section className="landing-section" id="how-it-works" aria-labelledby="how-title"><div className="landing-wrap">
    <header className="landing-section-heading"><h2 id="how-title">Как это работает</h2><p>От точки на карте до готового отчёта — за несколько секунд.</p></header>
    <ol className="landing-steps">{steps.map(([title, text], index) => <li className="landing-step" key={title}><span className="step-number">{index + 1}</span><h3>{title}</h3><p>{text}</p></li>)}</ol>
  </div></section>;
}
